module.exports = __webpack_public_path__ + "static/media/aecom.ae9bd7f0.png";